import React from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "./collection.css";
import { sliderSettings } from "../../utils/common";
import { collection} from "../../data/Data";

function CollectionCard() {
  return (
      <div id="residencies" className="r-wrapper">
          <div className="paddings innerWidth r-container">
            <div className="flexColStart r-head">
              {/* <span className="turquiseText">Join the community</span>
              <span className="primaryText">Programmes</span> */}
            </div>
            <Swiper {...sliderSettings} className="card-container">
              <SlideNextButton />
              {/* slider */}
              {collection.map((item, index) => {
                const { image, name, duration, description } = item
                return (
                <SwiperSlide key={index}>
                  <div className="flexColStart r-card">
                    <img src={image} alt="programme" />
    
                    <span className="secondaryText r-price">
                      <span>{duration}</span>
                    </span>
                    <span className="primaryText">{name}</span>
                    <span className="secondaryText">{description}</span>
                  </div>
                </SwiperSlide>
              )
            })}
            </Swiper>
          </div>
      </div>
  );
};
export default CollectionCard

  const SlideNextButton = () => {
  const swiper = useSwiper();
    return (
      <div className="flexCenter r-buttons">
        <button onClick={() => swiper.slidePrev()} className="r-prevButton">
          &lt;
        </button>
        <button onClick={() => swiper.slideNext()} className="r-nextButton">
          &gt;
        </button>
      </div>
  );
};
  